// extracted by mini-css-extract-plugin
export default {"name":"pool-name-section_name__i4306","section":"pool-name-section_section__cMCdB"};